var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('toolbarTitle', {
    attrs: {
      "title": `Passengers (${_vm.passengers ? _vm.passengers.length : 0})`
    }
  }), _c('div', {
    staticClass: "elevation-1 rounded passengers-table-wrapper"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.computedHeaders,
      "items": _vm.passengers,
      "items-per-page": -1,
      "disable-pagination": "",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: `item.firstName`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(item.firstName) + " " + _vm._s(item.lastName))])];
      }
    }, {
      key: `item.email`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(item.email ? item.email : "N/A") + " ")])];
      }
    }, {
      key: `item.phone`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(item.phone ? item.phone : "N/A") + " ")])];
      }
    }, {
      key: `item.birthdate`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(item.birthdate ? item.birthdate : "N/A") + " ")])];
      }
    }, {
      key: `item.countryOfResidence`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(item.countryOfResidence ? item.countryOfResidence : "N/A") + " ")])];
      }
    }, _vm.canBeEdited ? {
      key: `item.actions`,
      fn: function (_ref6) {
        var item = _ref6.item,
          index = _ref6.index;
        return [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openEditModal(item, index);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "size": "20",
            "color": "third"
          }
        }, [_vm._v("mdi-pencil")])], 1)];
      }
    } : null], null, true)
  })], 1), _c('v-dialog', {
    attrs: {
      "max-width": "600px",
      "scrollable": false,
      "persistent": _vm.loading
    },
    model: {
      value: _vm.editDialog,
      callback: function ($$v) {
        _vm.editDialog = $$v;
      },
      expression: "editDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "title",
    attrs: {
      "fixed": "",
      "color": "primary",
      "dense": "",
      "dark": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "ml-2"
  }, [_vm._v("Edit Passenger")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.loading
    },
    on: {
      "click": function ($event) {
        _vm.editDialog = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-card-text', {
    staticClass: "pt-5 modal-content"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "First Name",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "clearable": "",
      "rules": _vm.validate.required
    },
    model: {
      value: _vm.editedPassenger.firstName,
      callback: function ($$v) {
        _vm.$set(_vm.editedPassenger, "firstName", $$v);
      },
      expression: "editedPassenger.firstName"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Last Name",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "clearable": "",
      "rules": _vm.validate.required
    },
    model: {
      value: _vm.editedPassenger.lastName,
      callback: function ($$v) {
        _vm.$set(_vm.editedPassenger, "lastName", $$v);
      },
      expression: "editedPassenger.lastName"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-Mail",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "rules": _vm.validate.email,
      "clearable": ""
    },
    model: {
      value: _vm.editedPassenger.email,
      callback: function ($$v) {
        _vm.$set(_vm.editedPassenger, "email", $$v);
      },
      expression: "editedPassenger.email"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('VuePhoneNumberInput', {
    attrs: {
      "default-country-code": _vm.selectedCountryCode,
      "error": _vm.editedPassenger.phone && !_vm.phoneValid,
      "clearable": true
    },
    on: {
      "update": _vm.logPhone
    },
    model: {
      value: _vm.editedPassenger.phone,
      callback: function ($$v) {
        _vm.$set(_vm.editedPassenger, "phone", $$v);
      },
      expression: "editedPassenger.phone"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    staticClass: "mt-3 pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "info-message d-flex align-center pa-3"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "third"
    }
  }, [_vm._v("mdi-information-outline")]), _c('p', {
    staticClass: "mb-0 text-body-2 grey--text text--darken-2"
  }, [_vm._v(" This will update passenger information on all systems, including the tickets. ")])], 1)])], 1)], 1), _c('v-card-actions', {
    staticClass: "pb-4 pr-4"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "disabled": _vm.loading
    },
    on: {
      "click": function ($event) {
        _vm.editDialog = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('v-btn', {
    attrs: {
      "color": "accent",
      "loading": _vm.loading,
      "disabled": !_vm.isFormValid
    },
    on: {
      "click": _vm.savePassenger
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }